import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ConfigService } from './config/config.service';
import { AuthService } from './auth/auth.service';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Injectable({
  providedIn: 'root',
})
export class PortalLoggedinUsers {
  public loginIdFieldName: string = 'dbUserLoginId';
  private updateIntervalSubscription: Subscription | null = null;
  private authService!: AuthService;

  constructor(
    //private authService: AuthService,
    private dataService: DataService,
    private configService: ConfigService,
  ) {}

  setLogOutDateInDB(exitCode: PortalLogOutExitCode) {
    var loginId = localStorage.getItem(this.loginIdFieldName);
    if (loginId == null || loginId == "0") return;

    var url =
      environment.apiUrl +
      '/Portal/LoggedinUsers/setLogOutInPortalLoginUsersTable';
    var request: any = {
      loginId: loginId,
      exitCode: exitCode
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (result) => {},
      error: (e) => {},
    });
  }

  updateLastSeenDate() {
    const loginId = localStorage.getItem(this.loginIdFieldName);

    // Prevent "400" error
    if (loginId == null || loginId == "0") return;

    // Double-checking authentication, in *addition* to the server checking
    if (!this.authService.isAuthenticated()) {
      this.authService.logout(PortalLogOutExitCode.UpdateLastSeenDateCheck);
      return;
    }

    const url = `${environment.apiUrl}/Portal/LoggedinUsers/updateLastSeenDate`;
    const request = { loginId: loginId };

    this.dataService.getDataByToken(url, request).subscribe({
      next: (result) => {
        if(!result?.functionCompleted) {
          this.authService.logout(PortalLogOutExitCode.UpdateLastSeenDate);
        }
      },
      error: (e) => {
        if (e.status && e.status >= 400 && e.status <= 500) {
          this.authService.logout(PortalLogOutExitCode.UpdateLastSeenDateError);
        }
      },
    });
  }
  
  startUpdateLastSeenDateInterval(authService: AuthService) {
    this.authService = authService;
    if (
      this.updateIntervalSubscription != null ||
      !this.configService.loginStatisticsEnabled
    )
      return; // already started and make sure the login statistics configured at the Umbraco appsettings.json file
    this.updateIntervalSubscription = interval(
      this.configService.loginLastSeenIntervalInSeconds * 1000
    ).subscribe(() => {
      this.updateLastSeenDate();
    });
  }

  stopUpdateLastSeenDateInterval() {
    if (this.updateIntervalSubscription) {
      this.updateIntervalSubscription.unsubscribe();
      this.updateIntervalSubscription = null;
    }
  }

  ngOnDestroy(): void {
    if (this.updateIntervalSubscription) {
      this.updateIntervalSubscription.unsubscribe();
    }
  }
}
